import { render, staticRenderFns } from "./CadastroFormField.vue?vue&type=template&id=a1f8124c&scoped=true&lang=pug&"
import script from "./CadastroFormField.vue?vue&type=script&lang=js&"
export * from "./CadastroFormField.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFormField.vue?vue&type=style&index=0&id=a1f8124c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f8124c",
  null
  
)

export default component.exports